<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [noBow]="true"
      [title]="'Integrations'"
      [customBack]="backPage"
      [showLinkIcon]="true"
      [linkIcon]="'help-circle'"
      (linkAction)="goToContactConcierge()"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />
    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Integrations'" />
        </div>
      </tidy-desktop-header>
    }

    <div [class.integrations-scrollable-content]="windowService.isDesktopRes">
    @if (loaded) {
      @if (activeIntegrations?.length == 1) {
        <tidy-active-integrations
          [webhooks]="webhooks"
          [remoteAccessAddresses]="remoteAccessAddresses"
          [addresses]="addresses"
          [activeIntegrations]="activeIntegrations"
          [page]="'integrations'" />
      }
      @if (activeIntegrations?.length > 1) {
        <tidy-card>
          <tidy-card-button (action)="goToActiveIntegrations()" class="arrow-to-top" [hideArrow]="activeIntegrations?.length == 0">
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [header]="'Active Integrations'" />
            </tidy-row>
            @if (activeIntegrations?.length == 0) {
              <tidy-row>
                @if (integrationTypeForm?.value?.type === 'all') {
                  <tidy-text
                    [body]="'No integrations added'" />
                }
                @if (integrationTypeForm?.value?.type !== 'all') {
                  <tidy-text
                    [body]="('No ' | translate) + selectedIntegrationTypeName.toLowerCase() + (' integrations added' | translate)" />
                }
              </tidy-row>
            }
            @for (integration of activeIntegrations; track integration) {
              @if (integration.format === 'lock') {
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/integration-images/remote-lock.png'"
                    class="body-size" />
                  <tidy-text
                    [body]="'RemoteLock'"
                    [translate]="false" />
                  <tidy-text
                    [body]="': ' + integratedDevicesCount + (' devices integrated' | translate)" />
                  @if (integration?.addresses?.length) {
                    <tidy-text
                      [body]="' (' + integration?.addresses?.length + ' ' + (integration?.addresses?.length === 1 ? ('address' | translate) : ('addresses' | translate)) + ')'" />
                  }
                </tidy-row>
              }
              @if (integration.format === 'seam') {
                <tidy-row class="vertical-align-center">
                  @if (integration?.integration?.integration_data?.image_url) {
                    <tidy-image
                      [src]="integration?.integration?.integration_data?.image_url"
                      class="body-size" />
                  }
                  @if (!integration?.integration?.integration_data?.image_url) {
                    <tidy-image
                      [src]="'assets/img/integration-images/seam.png'"
                      class="body-size" />
                  }
                  <tidy-text
                    [body]="integration?.integration?.integration_data?.account_type_display_name ? ('Smart Locks: ' + integration?.integration?.integration_data?.account_type_display_name) : 'Smart Locks (Seam)'"
                    [translate]="false" />
                </tidy-row>
              }
              @if (integration.format === 'notification') {
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/integration-images/' + integration?.integration?.channel + '.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="integration?.integration?.channel === 'webhook' ? 'Webhook' : 'Slack'"
                    [translate]="false" />
                  <tidy-text
                    [body]="': ' + integration?.integration?.webhook_url" />
                  @if (integration?.addresses?.length) {
                    <tidy-text
                      [body]="' (' + integration?.addresses?.length + ' ' + (integration?.addresses?.length === 1 ? ('address' | translate) : ('addresses' | translate)) + ')'" />
                  }
                </tidy-row>
              }
              @if (integration.format !== 'notification' && integration.format !== 'lock' && integration.format !== 'seam') {
                <tidy-row class="vertical-align-center">
                  @if (integration?.guest_reservation_source_type?.format === 'api') {
                    <tidy-image
                      [src]="'assets/img/gold-link.svg'"
                      class="body-size" />
                  }
                  @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
                    <tidy-image
                      [src]="'assets/img/concierge.svg'"
                      class="body-size" />
                  }
                  @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
                    <tidy-image
                      [src]="'assets/img/ical.png'"
                      class="header-size" />
                  }
                  <tidy-text
                    [body]="integration.guest_reservation_source_type?.name | titlecase" />
                  @if (integration?.guest_reservation_source_type?.format === 'api') {
                    <tidy-text
                      [body]="': Direct Integration'" />
                  }
                  @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
                    <tidy-text
                      [body]="': Concierge Integration'" />
                  }
                  @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
                    <tidy-text
                      [body]="': iCal Integration '" />
                    }<span>&nbsp;</span>
                    @if (integration?.addresses?.length) {
                      <tidy-text
                        [body]="' (' + integration?.addresses?.length + ' ' + (integration?.addresses?.length === 1 ? ('address' | translate) : ('addresses' | translate)) + ')'" />
                    }
                  </tidy-row>
                }
              }
            </tidy-card-button>
          </tidy-card>
        }
        @if (pendingIntegrations?.length) {
          <tidy-row>
            <tidy-text
              [header]="'Pending Integrations'" />
          </tidy-row>
        }
        @for (integration of pendingIntegrations; track integration) {
          <tidy-card>
            <tidy-card-button (action)="goToUpdateIntegration(integration)" [hideArrow]="integration.state !== 'paused'" class="arrow-to-top">
              @if (integration.format === 'lock') {
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/integration-images/remote-lock.png'"
                    class="header-size" />
                  <tidy-text
                    [header]="'RemoteLock'"
                    [translate]="false" />
                </tidy-row>
              }
              @if (integration.format === 'notification') {
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/integration-images/' + integration?.integration?.channel + '.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="integration?.integration?.channel === 'webhook' ? 'Webhook' : 'Slack'"
                    [translate]="false" />
                </tidy-row>
              }
              @if (integration.format !== 'notification' && integration.format !== 'lock' && integration.format !== 'seam') {
                <tidy-row class="vertical-align-center">
                  @if (integration.state !== 'paused') {
                    <ion-spinner name="lines" class="card-loading-spinner" />
                  }
                  @if (integration.state === 'paused') {
                    <tidy-image
                      [src]="'assets/img/action-needed.svg'"
                      class="header-size" />
                  }
                  <tidy-text
                    [header]="integration.guest_reservation_source_type?.name | titlecase" />
                </tidy-row>
                <tidy-row>
                  @if (integration?.guest_reservation_source_type?.format === 'api') {
                    <tidy-text
                      [body]="'Direct Integration'" />
                  }
                  @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
                    <tidy-text
                      [body]="'Concierge Integration'" />
                  }
                  @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
                    <tidy-text
                      [body]="'iCal Integration '" />
                  }
                </tidy-row>
              }
              @if (integration.state !== 'paused' && integration?.guest_reservation_source_type?.format !== 'concierge_integration') {
                @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length <= 0) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      body="Sync Pending.." />
                  </tidy-row>
                }
                @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length > 0) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      body="Syncing guest reservations.." />
                  </tidy-row>
                }
              }
              @if (integration.state === 'paused') {
                <tidy-row>
                  <tidy-text
                    body="There was an issue syncing this integration. Please update your integration details." />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px">
          <tidy-text
            [header]="'Add Integrations'" />
          <tidy-checkbox
            (checkedChange)="toggleShowDiscounts()"
            [(checked)]="termsChecked"
          [items]="[
            {
              viewValue: 'Show Discounts', value: true
            }
          ]"
          [initValue]="false" />
      </div>
      <tidy-row style="margin-bottom: 10px">
        <form [formGroup]="form" novalidate action="#" class="full-width">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/svg/search.svg'"
            class="header-search full-width" />
        </form>
      </tidy-row>
      @for (item of integrationItems; track item) {
        <ng-container style="display: flex">
          <div class="integrations-chip" (click)="changeSelectedIntegrationType(item.value)" [ngStyle]="{'background-color': item.show ? 'var(--tidy-desktop-nav-selected)' : 'var(--tidy-bg-secondary)'}" >
            <div class="integrations-chip-text" [class.white]="item.show" >
              {{item.viewValue | translate}}
            </div>
          </div>
        </ng-container>
      }
      <tidy-row>
        <tidy-text
          [body]="'<b>Featured</b>'" />
      </tidy-row>
      @if (!shownAllFeaturedIntegrations?.length || (showDiscounts && !hasShownAllFeaturedIntegrationsDiscounts)) {
        <tidy-alert>
          <tidy-text
            [body]="'No results'" />
        </tidy-alert>
      }
      @for (integration of shownAllFeaturedIntegrations; track integration; let i = $index; let last = $last; let even = $even) {
        @if (showDiscounts ? integration?.discount : true) {
          <div style="position: relative;">
            @if (integration?.discount) {
              <tidy-image
                [src]="'assets/img/star.svg'"
                style="width: 25px; position: absolute; top: -10px; left: -10px; z-index: 1;" />
            }
            <tidy-card style="padding: 10px; position: relative; z-index: 0;">
              <tidy-card-button (action)="goToAddIntegration(integration)">
                <tidy-row>
                  <div style="display: flex; align-items: center;">
                    <div style="flex: 0 0 auto; width: 60px; margin: auto;">
                      <tidy-image
                        [src]="integration?.logo_url"
                        style="width:100%; max-height: 30px" />
                    </div>
                    <div style="flex: 1; margin-left: 10px;">
                      <tidy-row class="vertical-align-center">
                        <tidy-text
                          [header]="integration?.name"
                          [translate]="false" />
                        @if (integration?.discount && windowService.isDesktopRes) {
                          <tidy-image
                            [src]="'assets/img/coupon.svg'"
                            style="margin-left: 10px; width: 20px" />
                          <tidy-text
                            [body]="integration?.discount" />
                        }
                      </tidy-row>
                      @if (integration?.discount && !windowService.isDesktopRes) {
                        <tidy-row class="vertical-align-center">
                          <tidy-image
                            [src]="'assets/img/coupon.svg'"
                            style="width: 20px" />
                          <tidy-text
                            [body]="integration?.discount" />
                        </tidy-row>
                      }
                      @if (integration?.short_description !== null) {
                        <tidy-row>
                          <tidy-text
                            [body]="integration?.short_description"
                        style="overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                                line-clamp: 2;
                        -webkit-box-orient: vertical;" />
                        </tidy-row>
                      }
                    </div>
                  </div>
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          </div>
        }
      }
      <tidy-row>
        <tidy-text
          [body]="'<b>All Integrations</b>'" />
      </tidy-row>
      @if (!shownAllIntegrations?.length || (showDiscounts && !hasShownAllIntegrationsDiscounts)) {
        <tidy-alert>
          <tidy-text
            [body]="'No results'" />
        </tidy-alert>
      }
      @for (integration of shownAllIntegrations; track integration; let i = $index; let last = $last) {
        @if (!windowService?.isDesktopRes && (showDiscounts ? integration?.discount : true)) {
          <div style="position: relative;">
            @if (integration?.discount) {
              <tidy-image
                [src]="'assets/img/star.svg'"
                style="width: 25px; position: absolute; top: -10px; left: -10px; z-index: 1;" />
            }
            <tidy-card style="padding: 10px">
              <tidy-card-button (action)="goToAddIntegration(integration)">
                <tidy-row>
                  <ion-row>
                    <ion-col size="3" style="margin: auto">
                      <tidy-image
                        [src]="integration?.logo_url"
                        style="width:100%; max-height: 65px" />
                    </ion-col>
                    <ion-col>
                      <tidy-row>
                        <tidy-text
                          [header]="integration?.name"
                          [translate]="false" />
                        @if (integration?.discount) {
                          <tidy-image
                            [src]="'assets/img/coupon.svg'"
                            style="margin-left: 10px; width: 20px" />
                          <tidy-text
                            [body]="integration?.discount" />
                        }
                      </tidy-row>
                      @if (integration?.short_description !== null) {
                        <tidy-row>
                          <tidy-text
                            [body]="integration?.short_description"
                        style="overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                                line-clamp: 2;
                        -webkit-box-orient: vertical;" />
                        </tidy-row>
                      }
                    </ion-col>
                  </ion-row>
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          </div>
        }
        @if (i % 3 === 0 && windowService?.isDesktopRes) {
          <div style="margin-bottom: 0px; display: flex; gap: 10px;">
            @if (showDiscounts ? integration?.discount : true) {
              <div style="position: relative; flex: 1; width: 33.33%; display: flex; flex-direction: column;">
                @if (integration?.discount) {
                  <tidy-image
                    [src]="'assets/img/star.svg'"
                    style="width: 25px; position: absolute; top: -10px; left: -10px; z-index: 1;" />
                }
                <tidy-card style="padding: 10px; flex-grow: 1; display: flex; flex-direction: column;">
                  <tidy-card-button (action)="goToAddIntegration(integration)" style="flex-grow: 1; display: flex; flex-direction: column;">
                    <tidy-row style="flex-grow: 1;">
                      <ion-row style="height: 100%;">
                        <ion-col size="3" style="margin: auto">
                          <tidy-image
                            [src]="integration?.logo_url"
                            style="width:100%; max-height: 65px" />
                        </ion-col>
                        <ion-col style="display: flex; flex-direction: column;">
                          <tidy-row class="vertical-align-middle">
                            <tidy-text
                              [header]="integration?.name"
                              [translate]="false" />
                            @if (integration?.discount) {
                              <tidy-image
                                [src]="'assets/img/coupon.svg'"
                                style="margin-left: 10px; width: 20px" />
                              <tidy-text
                                [body]="integration?.discount" />
                            }
                          </tidy-row>
                          @if (integration?.short_description !== null) {
                            <tidy-row style="flex-grow: 1;">
                              <tidy-text
                                [body]="integration?.short_description"
                          style="overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                                  line-clamp: 2;
                          -webkit-box-orient: vertical;" />
                            </tidy-row>
                          }
                        </ion-col>
                      </ion-row>
                    </tidy-row>
                  </tidy-card-button>
                </tidy-card>
              </div>
            }
            @if (showDiscounts ? integration?.discount : true) {
              <div style="position: relative; flex: 1; width: 33.33%; display: flex; flex-direction: column;">
                @if (shownAllIntegrations[i+1]?.discount) {
                  <tidy-image
                    [src]="'assets/img/star.svg'"
                    style="width: 25px; position: absolute; top: -10px; left: -10px; z-index: 1;" />
                }
                @if (shownAllIntegrations[i+1]) {
                  <tidy-card style="padding: 10px; flex-grow: 1; display: flex; flex-direction: column;">
                    <tidy-card-button (action)="goToAddIntegration(shownAllIntegrations[i+1])" style="flex-grow: 1; display: flex; flex-direction: column;">
                      <tidy-row style="flex-grow: 1;">
                        <ion-row style="height: 100%;">
                          <ion-col size="3" style="margin: auto">
                            <tidy-image
                              [src]="shownAllIntegrations[i+1]?.logo_url"
                              style="width:100%; max-height: 65px" />
                          </ion-col>
                          <ion-col style="display: flex; flex-direction: column;">
                            <tidy-row class="vertical-align-middle">
                              <tidy-text
                                [header]="shownAllIntegrations[i+1]?.name"
                                [translate]="false" />
                              @if (shownAllIntegrations[i+1]?.discount) {
                                <tidy-image
                                  [src]="'assets/img/coupon.svg'"
                                  style="margin-left: 10px; width: 20px" />
                                <tidy-text
                                  [body]="shownAllIntegrations[i+1]?.discount" />
                              }
                            </tidy-row>
                            @if (shownAllIntegrations[i+1]?.short_description !== null) {
                              <tidy-row style="flex-grow: 1;">
                                <tidy-text
                                  [body]="shownAllIntegrations[i+1]?.short_description"
                          style="overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                                  line-clamp: 2;
                          -webkit-box-orient: vertical;" />
                              </tidy-row>
                            }
                          </ion-col>
                        </ion-row>
                      </tidy-row>
                    </tidy-card-button>
                  </tidy-card>
                }
              </div>
            }
            @if (showDiscounts ? integration?.discount : true) {
              <div style="position: relative; flex: 1; width: 33.33%; display: flex; flex-direction: column;">
                @if (shownAllIntegrations[i+2]?.discount) {
                  <tidy-image
                    [src]="'assets/img/star.svg'"
                    style="width: 25px; position: absolute; top: -10px; left: -10px; z-index: 1;" />
                }
                @if (shownAllIntegrations[i+2]) {
                  <tidy-card style="padding: 10px; flex-grow: 1; display: flex; flex-direction: column;">
                    <tidy-card-button (action)="goToAddIntegration(shownAllIntegrations[i+2])" style="flex-grow: 1; display: flex; flex-direction: column;">
                      <tidy-row style="flex-grow: 1;">
                        <ion-row style="height: 100%;">
                          <ion-col size="3" style="margin: auto">
                            <tidy-image
                              [src]="shownAllIntegrations[i+2]?.logo_url"
                              style="width:100%; max-height: 65px" />
                          </ion-col>
                          <ion-col style="display: flex; flex-direction: column;">
                            <tidy-row class="vertical-align-middle">
                              <tidy-text
                                [header]="shownAllIntegrations[i+2]?.name"
                                [translate]="false" />
                              @if (shownAllIntegrations[i+2]?.discount) {
                                <tidy-image
                                  [src]="'assets/img/coupon.svg'"
                                  style="margin-left: 10px; width: 20px" />
                                <tidy-text
                                  [body]="shownAllIntegrations[i+2]?.discount" />
                              }
                            </tidy-row>
                            @if (shownAllIntegrations[i+2]?.short_description !== null) {
                              <tidy-row style="flex-grow: 1;">
                                <tidy-text
                                  [body]="shownAllIntegrations[i+2]?.short_description"
                          style="overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;
                                  line-clamp: 2;
                          -webkit-box-orient: vertical;" />
                              </tidy-row>
                            }
                          </ion-col>
                        </ion-row>
                      </tidy-row>
                    </tidy-card-button>
                  </tidy-card>
                }
              </div>
            }
          </div>
        }
      }
    }

    </div>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />